module.exports = __webpack_public_path__ + "img/Ford.046f5aae.svg";